import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { BRAND, comparisonRows } from '../data/resinContent';
export function ComparisonSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="comparison-title" data-id="element-52" data-mp="3e7kcjx6mgukl">
      <div className="mx-auto max-w-3xl px-5" data-id="element-53" data-mp="39ceiuc6zably">
        <h2 id="comparison-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-54" data-mp="34gfx6wd1b7p8">
          What changes with {BRAND}
        </h2>

        <div className="mt-8 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-x-4 border-b border-charcoal-600 pb-2 text-[9.5px] font-semibold uppercase tracking-[0.2em] sm:grid-cols-[8rem_minmax(0,1fr)_minmax(0,1fr)] sm:gap-x-6" data-id="element-55" data-mp="2vdomwzvwahz6">
          <span className="hidden text-muted sm:block" data-id="element-56" data-mp="ooigvw7he69p" />
          <span className="text-muted" data-id="element-57" data-mp="oo0aw7v0odol">Without the system</span>
          <span className="text-champagne" data-id="element-58" data-mp="jp5rp4t50n3y">With the system</span>
        </div>

        <ul className="divide-y divide-charcoal-600 border-b border-charcoal-600" data-id="element-59" data-mp="3afcqc6y82uto">
          {comparisonRows.map(row => <li key={row.aspect} className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] items-start gap-x-4 py-4 sm:grid-cols-[8rem_minmax(0,1fr)_minmax(0,1fr)] sm:gap-x-6" data-id="element-60" data-mp="3egy8o7tj01b9">
              <p className="col-span-2 mb-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory-300 sm:col-span-1 sm:mb-0 sm:self-center" data-id="element-61" data-mp="35gt4e6jmpj1b">
                {row.aspect}
              </p>
              <p className="flex items-start gap-2 text-[13.5px] leading-snug text-body sm:self-center" data-id="element-62" data-mp="1xzv45xvvgcy">
                <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-63" data-mp="3jf9kup7amnwn" />
                {row.without}
              </p>
              <p className="flex items-start gap-2 text-[13.5px] font-medium leading-snug text-ivory-50 sm:self-center" data-id="element-64" data-mp="fykbkvgbt03a">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-65" data-mp="kqu6yr07mscy" />
                {row.with}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}